/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
//Custom libraries
import { REG_EX } from "../constants/common";

const addressUtil = {
  optionalAddressFields: ["lastNameMat", "reference"],
  addressFormFields: [
    "firstName",
    "lastName",
    "lastNameMat",
    "addressLine1",
    "addressLine2",
    "city",
    "country",
    "state",
    "zipCode",
    "phone1",
    "number",
    "INumber",
    "nickName",
    "email1",
    "addressType",
    "address1",
    "numExt",
    "reference"
  ],

  validateAddressForm: (formData: any, edit?: boolean) => {
    const editVal = edit ? edit : false;

    for (let key in formData) {
      if (!addressUtil.optionalAddressFields.includes(key)) {
        if (formData[key] !== undefined && formData[key].trim() === "") {
          return false;
        }
      }
    }
    if (!addressUtil.validatePhoneNumber(formData.phone1)) {
      return false;
    }
    if (!addressUtil.validateEmail(formData.email1)) {
      // console.log(formData.number);
      return false;
    }

    if (!editVal && !addressUtil.validateNickName(formData.nickName)) {
      return false;
    }

    if (!addressUtil.validateZipCode(formData.zipCode)) {
      return false;
    }

    return true;
  },

  validateInformationForm: (formData: any) => {
    for (let key in formData) {
      if (formData[key] !== undefined && formData[key].trim() === "") {
        return false;
      }
    }
    if (!addressUtil.validateEmail(formData.email)) {
      console.log("no pasa email");
      return false;
    }
    if (!addressUtil.validatePhoneNumber(formData.phone)) {
      console.log("no pasa telefono");
      return false;
    }
    if (!addressUtil.validateNickName(formData.name)) {
      console.log("no pasa nombre");
      return false;
    }

    if (!addressUtil.validateNickName(formData.lastname)) {
      console.log("no pasa apellido");
      return false;
    }

    return true;
  },

  validatePhoneNumber: (phoneNumber: string) => {
    const PHONE = REG_EX.PHONE;
    return (
      phoneNumber === undefined ||
      phoneNumber.trim() === "" ||
      PHONE.test(phoneNumber.trim())
    );
  },

  validateZipCode: (zipCode: string) => {
    return (
      zipCode === undefined || zipCode.trim() === "" || zipCode.length >= 5
    );
  },

  validateNumber: (number: string) => {
    return number === undefined || number.trim() === "" || number.length >= 3;
  },

  validateState: (state: string) => {
    return state === undefined || state.trim() === "";
  },

  validateEmail: (email: string) => {
    const EMAIL = REG_EX.EMAIL;
    return email === undefined || email.trim() === "" || EMAIL.test(email);
  },

  validateNickName: (nickName: string) => {
    const NICKNAME_ALPHA_NUMERIC_SPECIAL_CHAR =
      REG_EX.NICKNAME_ALPHA_NUMERIC_SPECIAL_CHAR;
    return (
      nickName === undefined ||
      nickName.trim() === "" ||
      NICKNAME_ALPHA_NUMERIC_SPECIAL_CHAR.test(nickName)
    );
  },

  validateSocio: (socio: string) => {
    const SOCIO = REG_EX.SOCIO;
    return socio === undefined || socio.trim() === "" || SOCIO.test(socio);
  },

  removeLeadingTrailingWhiteSpace: (formData: any): any => {
    let result: any = {};
    // remove leading and trailing white space from all form input fields.
    if (formData !== undefined && formData !== null) {
      Object.keys(formData).forEach((key) => {
        let value = formData[key].trim();
        result[key] = value;
      });
    }
    return result;
  },

  removeIgnorableAddressFormFields: (formData: any): any => {
    let result: any = { ...formData };
    for (let key in result) {
      if (!addressUtil.addressFormFields.includes(key)) {
        delete result[key];
      }
    }
    console.log(result);
    return result;
  },
};

export default addressUtil;
